var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon",on:{"click":_vm.click}},[_c('img',{staticClass:"icon-img",attrs:{"src":_vm.icon}}),_c('div',{staticClass:"icon-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }